// src/components/ColorPicker.js
import React from 'react';
import styled from 'styled-components';
import { ChromePicker } from 'react-color';

const CustomChromePicker = styled(ChromePicker)`
  .chrome-picker {
    width: 100% !important;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1) !important;
  }
`;

const ColorPicker = ({ inputColor, handleColorChange }) => (
  <CustomChromePicker color={inputColor} onChange={handleColorChange} />
);

export default ColorPicker;
